/* eslint-disable jsx-a11y/anchor-is-valid */
import { IContentIDs } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import HideIf from "util/HideIf";
import { renderHTML } from "../../util/DomHelper";
import { isKit } from "../../util/product/is-kit";
import styles from "./ProductDescriptionFromStaticContent.module.scss";
import ShowMoreAndLess from "./showMoreAndLess/ShowMoreAndLessContainer";
const ID_ORDER = ["PRODUCT_DESCRIPTION"];

function ProductDescriptionFromStaticContent(props: any) {
  const { t } = useTranslation("product");
  const { showMore = false, extendedDescription, isFeaturesAndBenefitsNodeExists } = props;
  const isKitProduct = isKit({ extendedDescription });

  // Pass array of contentIds to show or dont pass aynything to show all contentIDs
  const { contentIds, displayContentIDs = [] } = props;

  let contentToShow = null;
  if (contentIds) {
    contentToShow = contentIds
      .filter((_:IContentIDs) => _.uiDetails)
      .filter((_:IContentIDs) => _.uiDetails.isActive !== false)
      .filter((_:IContentIDs) => displayContentIDs.length === 0 || (displayContentIDs.length > 0 && displayContentIDs.includes(_.uiDetails.uiType)))
      .sort((a: any, b: any) => ID_ORDER.indexOf(b.uiDetails.uiType) - ID_ORDER.indexOf(a.uiDetails.uiType))
      .map((_: any, index: any) => {
        let title = "";
        if (_.uiDetails.uiType === "PRODUCT_FEATURES_BENEFITS") {
          title = isKitProduct ? _.uiDetails.content.title || t("Features & Benefits") : t("Features & Benefits");
        } else if (_.uiDetails.uiType === "PRODUCT_DESCRIPTION") {
          title = isKitProduct ? _.uiDetails.content.title : "";
        }
        const articleContentExists = _.uiDetails.content !== undefined && _.uiDetails.content.article !== undefined && _.uiDetails.content.article.length !== 0;
        const doNotShowFBForProductPage = articleContentExists && !(isFeaturesAndBenefitsNodeExists && _.uiDetails.uiType === "PRODUCT_FEATURES_BENEFITS");
        // donot show featuers and benefits in case seperate node is coming in pageContent

        const innerContent = (
          <HideIf
            key={index}
            show={doNotShowFBForProductPage}
          >

            <PAText
              fontSize={FONT_SIZE[2]}
              inlineBlock
              bold
              className={styles.title}
            >
              {title}

            </PAText>

            <div
              dangerouslySetInnerHTML={renderHTML(_.uiDetails?.content?.article)}
            />

            <div />
          </HideIf>
        );
        return (
          showMore
            ? (
              <ShowMoreAndLess
                contentDescription={
                  innerContent
                }
                key={index}
              />
            )
            : innerContent

        );
      });

    // Uncomment this to show content ids that are mapped but there is no content for it
    // if (!contentToShow.length) {
    //   contentToShow = contentIds
    //     .filter((_:IContentIDs) => !_.uiDetails)
    //     .map((_:IContentIDs) => (
    //       <div key={_.url}>
    //         {`${_.url }: 404`}
    //       </div>
    //     ));
    // }
  }
  return contentToShow;
}

export default ProductDescriptionFromStaticContent;
